<template>
  <div class="success-case-content">
    <div class="swiper-box">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in list" :key="index">
              <div class="text">{{ item.title }}</div>
              <img :src="item.imgSrc" />
            </div>
          </div>
        </div>
        <div class="button-prev" @click="swiperPrev">
          <img src="@/assets/images/sem-local/case-left-btn.png" alt="" />
        </div>
        <div class="button-next" @click="swiperNext">
          <img src="@/assets/images/sem-local/case-right-btn.png" alt="" />
        </div>
      </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
export default {
  props: {
    list: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      planSwiper: '',
      prevShowBtn: false,
      NextprevShowBtn: true,
      count: 0
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      this.planSwiper = new Swiper('.swiper-container', {
        loop: true,
        spaceBetween: 30,
        slidesPerView: 1,
      })
    },
    swiperPrev() {
      this.planSwiper.slidePrev()
      this.$emit('prevChangeBg')
    },
    swiperNext() {
      this.planSwiper.slideNext()
      this.$emit('nextChangeBg')
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../../assets/css/swiper.min.css';
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
.success-case-content {
  width: 1000px;
  max-width: 1320px;
  margin: 0 auto;
}
.swiper-box {
  width: 100%;
  height: 466px;
  margin: 0 auto;
  position: relative;

  .button-prev, .button-next {
    position: absolute;
    top: 208px;
    width: 70px;
    height: 70px;
    cursor: pointer;
  }
  .button-prev {
    left: -74px;
  }
  .button-next {
    right: -74px;
  }
  .swiper-container {
    width: 100%;
    height: 100%;
    border-radius: 18px;
    .swiper-wrapper {
      height: 100%;
      .swiper-slide {
        object-fit: cover;
        background: #ffffff;
        border-radius: 4px;
        img {
          width: 100%;
          height: 86%;
        }
        .text {
          padding: 24px 0 11px 0;
          text-align: center;
          font-size: 20px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
        }
      }
    }
  }
}
</style>